import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CapabilitiesProvider } from "./context/CapabilitiesContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import BusinessDetail from "./pages/BusinessDetail";
import { LoginPage, RegisterPage } from "./pages/Auth";
import CustomerDashboard from "./pages/CustomerDashboard";
import BusinessDashboard from "./pages/business";
import AdminDashboard from "./pages/AdminDashboard";
import ChangePassword from "./pages/ChangePassword";
import { Privacy, CookiePolicy, Dpa, Terms } from "./pages/Legal";
import DeleteConfirm from "./pages/DeleteConfirm";
import BookingCancel from "./pages/BookingCancel";
import ProposalAccept from "./pages/ProposalAccept";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import BusinessPrivacy from "./pages/BusinessPrivacy";
import PrivacyCenter from "./pages/PrivacyCenter";
import StatusPage from "./pages/StatusPage";
import DemoTour from "./pages/DemoTour";
import StatusBanner from "./components/StatusBanner";
import { Toaster } from "./components/ui/sonner";
import BugReportButton from "./components/BugReportButton";
import AcceptStaffInvite from "./pages/AcceptStaffInvite";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CapabilitiesProvider>
          <StatusBanner />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/demo" element={<DemoTour />} />
            <Route path="/book/:id" element={<BusinessDetail />} />
            <Route path="/status" element={<StatusPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/dpa" element={<Dpa />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/p/:bid/privacy" element={<BusinessPrivacy />} />
            <Route path="/account/delete-confirm" element={<DeleteConfirm />} />
            <Route path="/booking/cancel" element={<BookingCancel />} />
            <Route path="/proposal/accept" element={<ProposalAccept />} />
            <Route path="/staff-invite" element={<AcceptStaffInvite />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/me" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
            <Route path="/me/privacy" element={<ProtectedRoute><PrivacyCenter /></ProtectedRoute>} />
            <Route path="/account/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path="/business" element={<ProtectedRoute roles={["business", "admin", "staff_user"]}><BusinessDashboard /></ProtectedRoute>} />
            <Route path="/business/setup" element={<ProtectedRoute roles={["business", "admin", "staff_user"]}><BusinessDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
          <Footer />
          <CookieBanner />
          <BugReportButton />
          <Toaster />
          </CapabilitiesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
